import { AbstractControl } from '@angular/forms';

export const ageValidator = (control: AbstractControl): { [key: string]: boolean } | null => {
  const currentDate = new Date();
  if (control.value !== null && (isNaN(control.value) || control.value > currentDate)) {
    return { ageValidator: false };
  }
  return null;
};
